import { FullscreenExitOutlined } from '@ant-design/icons'
import { setGlobalTags } from '@/features/SetSixLawsInfo/setSixLawsInfo'
import { useAppSelector, useAppDispatch } from '@/hooks'
import { getSixLawsImageUrl } from '@/assets/images/SixLawsPage/imageMap'

const Weizhi = (props) => {
  const dispatch = useAppDispatch()
  const setShowPanel = props.setShowPanel
  const weizhiTrees = useAppSelector((state) => state.sixLawsInfo.globalTagTree.构图)
  const globalTags = useAppSelector((state) => state.sixLawsInfo.globalTags)

  return (
    <div className='weizhi-panel'>
      <div className='weizhi-title'>
        <h2>经营位置</h2>
        <FullscreenExitOutlined
          className='weizhi-control-exitFullscreen'
          onClick={() => {
            setShowPanel(0)
          }}
        />
      </div>
      <div className='weizhi-container'>
        <div className='weizhi-tags'>
          {weizhiTrees.map((item) => {
            return (
              <div
                className={
                  globalTags.构图.length > 0 && globalTags.构图[0] === item.title
                    ? 'weizhi-tags-goutuContent-selected'
                    : 'weizhi-tags-goutuContent'
                }
                onClick={() => {
                  const newGlobalTags = JSON.parse(JSON.stringify(globalTags))
                  if (newGlobalTags.构图.length > 0) {
                    newGlobalTags.构图[0] = item.title
                  } else {
                    newGlobalTags.构图.push(item.title)
                  }
                  dispatch(setGlobalTags(newGlobalTags))
                }}
                key={item.title}
              >
                <div className='weizhi-tags-goutuContent-title'>{item.title}</div>
                <div className='weizhi-tags-goutuContent-divider'></div>
                <div className='weizhi-tags-goutuContent-content'>
                  {item.imgSrc ? (
                    <img
                      src={getSixLawsImageUrl(item.imgSrc)}
                      alt=''
                      className='weizhi-tags-goutuContent-content-img'
                    />
                  ) : null}
                  {item.description ? (
                    <div className='weizhi-tags-goutuContent-content-description'>
                      {item.description}
                    </div>
                  ) : null}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Weizhi
